import { atom } from "nanostores"

export const $isNewLoan = atom(false)
